module.exports = __webpack_public_path__ + "static/media/error_404.b393f1db.png";